<template>
  <div
    v-for="item in items"
    :key="item.slug"
    class="group col-span-6 flex cursor-pointer flex-col justify-between rounded-lg border border-border transition-colors duration-200 hover:border-primary hover:shadow-[0_4px_14px_0_rgba(83,36,188,0.08)] md:col-span-3 lg:col-span-2"
  >
    <div class="flex flex-col justify-start">
      <div class="min-h-28 p-5">
        <div class="flex justify-between">
          <div>
            <p class="mb-1 flex items-center text-base font-semibold text-foreground">
              <span>{{ $t(`pages.settings.accountPage.payments.${item.product_name}.title`) }}</span>
              <span
                v-if="item.stores.length > 1"
                class="cursor-pointer pl-2 text-xs text-muted-foreground hover:text-primary/80 hover:underline"
                @click="isModalOpen = true"
                >{{ item.stores.length }} {{ $t(`pages.settings.subscriptionPage.stores`) }}</span
              >
              <BaseModal
                :is-open="isModalOpen"
                size="3xl"
                :link-text="$t('global.words.close')"
                @close="isModalOpen = false"
                @click="isModalOpen = false"
              >
                <h4 class="mb-6 text-lg font-semibold text-foreground">
                  {{ $t(`pages.settings.subscriptionPage.storesInvolved`) }}
                  {{ $t(`pages.settings.accountPage.payments.${item.slug}.title`) }}
                </h4>
                <span
                  v-for="store in item.stores"
                  :key="store.store_id"
                  class="mx-2 rounded-md bg-primary/10 px-2 py-1.5 text-xs font-semibold leading-5 text-primary"
                >
                  {{ store.store_name }}
                </span>
              </BaseModal>
            </p>
            <p class="mb-2 text-sm text-foreground">
              <span v-if="!item.end_date">{{ $t(`pages.settings.subscriptionPage.since`) }} </span>
              <span v-else>{{ $t(`pages.settings.subscriptionPage.from`) }} </span>
              <span> {{ item.start_date }} </span>
              <span v-if="item.end_date"> {{ $t(`pages.settings.subscriptionPage.to`) }} {{ item.end_date }}</span>
              <span v-if="item.smsIncluded">
                ·
                <span class="font-medium"
                  >{{ item.smsIncluded }} {{ $t(`pages.settings.subscriptionPage.includedSms`) }}</span
                ></span
              >
            </p>
          </div>
          <div class="mb-4 flex flex-row items-center space-x-2">
            <p
              v-if="!item.end_date"
              class="rounded-md bg-primary/10 px-2 py-1.5 text-xs font-semibold leading-5 text-primary"
            >
              {{ item.price_ht }}€ {{ $t(`pages.settings.subscriptionPage.priceSuffix`) }}
            </p>
            <p v-else class="rounded-md bg-red-100 px-2 py-1.5 text-xs font-semibold leading-5 text-red-800">
              {{ $t(`pages.settings.subscriptionPage.canceled`) }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="flex min-h-16 items-center justify-between border-t px-5 text-primary">
      <p class="text-sm text-foreground">
        <span>{{ $t(`pages.settings.subscriptionPage.billedTo`) }} {{ item.client }}</span>
      </p>
    </div>
  </div>
</template>

<script>
import { BaseModal } from '@/ui/dialog'
export default {
  components: {
    BaseModal
  },
  props: {
    items: {
      type: Object,
      required: true
    }
  },
  data: () => {
    return {
      subscription: null,
      isModalOpen: false
    }
  },
  methods: {}
}
</script>
